const pluginName = 'teamsPlugin';
const dataKey = `plugin_${pluginName}`;
const defaults = {
  registrationPlugin: null,
  registrationUrl: null,
  registrantIndex: 1,
  registrantsPersonalInformation: null,
  newFundraisingFlow: false,
};
const selectors = {
  teamCategoryContainer: '[data-js-team-category-container]',
  teamCategory: '[data-js-team-category]',
  teamCreateNew: '.js-team-create-new',
  teamJoinExisting: '.js-team-join-existing',
  teamJoinReserved: '.js-team-join-reserved',
  teamQuestions: '.js-team-questions',
  teamFundraisingSettings: '[data-js-team-fundraising-settings]',
  teamStateSelectors: '[data-js-team-state-selector-fieldset]',
  teamNameFeedback: '.js-team-name-feedback',
  teamNameFeedbackIcon: '.js-team-name-feedback-icon',
  joiningTeamPassword: '.js-joining-team-password',
  teamsJoinFormControl: '.js-teams-join-form-control',
  teamSpinner: '#team-spinner',
  teamNameInput: 'input[name="teams[team-name]"]',
  teamStateInput: 'input[name="teams[state]"]',
  teamsJoinFormControlChange: '.js-teams-join-form-control',
  teamFundraisingCommitment: '[data-js-team-fundraising-commitment]',
  teamStateSelector: '.team-state-selector',
  teamFundraisingOptIn: 'input[name="teams[is_fundraising_team]"]',
  selectedTeamFundraisingOrganization: '[name="teams[selected_fundraising_organization]"]',
  teamCharityLock: '[data-team-charity-lock="1"]',
};
const classes = {
  hidden: 'd-none hidden',
  hasSuccess: 'has-success',
  hasError: 'has-error',
  iconSpinner: 'fa-spinner fa-pulse',
  iconCheck: 'fa-check-circle',
  iconTimes: 'fa-times-circle',
};
const routes = {
  validateTeamName: '__registrationUrl__/registrant/__registrantIndex__/teams/name',
  loadCategories: '__registrationUrl__/registrant/__registrantIndex__/teams/__teamState__',
  loadQuestions: '__registrationUrl__/registrant/__registrantIndex__/teams/__categoryId__/questions',
  loadPreferredFundraisingOrganizationSelection: '__registrationUrl__/registrant/__registrantIndex__/team/__teamId__/get-preferred-fundraising-organization-selection',
  loadJoinExistingForm: '__registrationUrl__/registrant/__registrantIndex__/teams/__categoryId__/join/joining-existing',
  loadJoinReservedForm: '__registrationUrl__/registrant/__registrantIndex__/teams/__categoryId__/join/joining-reserved',
  loadCreateForm: '__registrationUrl__/registrant/__registrantIndex__/teams/__categoryId__/create',
};
const teamStates = {
  joiningExisting: 'joining-existing',
  joiningReserved: 'joining-reserved',
  creating: 'creating',
  noTeam: 'no-team',
  joiningPreSelected: 'joining-pre-selected',
};

$(() => {
  let settings = {};
  let $pluginContainer = null;
  let $teamStates;
  let $teamSpinner;

  /**
   * Clear out the existing team containers
   */
  const clearContainers = () => {
    $pluginContainer
      .find([
        selectors.teamCategoryContainer,
        selectors.teamCreateNew,
        selectors.teamJoinExisting,
        selectors.teamJoinReserved,
        selectors.teamQuestions,
        selectors.teamFundraisingSettings,
      ].join(', '))
      .empty();
  };

  const clearPreferredFundraisingContainer = () => {
    $pluginContainer
      .find(selectors.teamFundraisingSettings)
      .html('')
      .addClass(classes.hidden);
  };

  const triggerFundraisingOrganizationChanged = (fundraisingOrganizationUuid = null) => {
    if (!$(selectors.teamCharityLock).length) {
      return;
    }

    $(document).trigger(
      'teams.fundraisingOrganizationChanged',
      [fundraisingOrganizationUuid || null],
    );
  };

  /**
   * Show the team spinner
   */
  const showLoadingState = () => {
    $teamSpinner.removeClass(classes.hidden);
    $pluginContainer.find(selectors.teamStateSelectors).prop('disabled', true);
  };

  /**
   * Hide the team spinner
   */
  const hideLoadingState = () => {
    $teamSpinner.addClass(classes.hidden);
    $pluginContainer.find(selectors.teamStateSelectors).prop('disabled', false);
  };

  /**
   * Run the questions plugin but like only if it should
   * @param $element
   */
  const initializeTeamQuestions = ($element) => {
    if (!$element) {
      return;
    }

    if (!$element.length) {
      return;
    }

    // hack to get the JS to wait for DOM update before doing things
    $element[0].getBoundingClientRect();

    if (!$element.children().length) {
      return;
    }

    $element
      .questionsPlugin({
        registrationPlugin: settings.registrationPlugin,
        i18n: settings.i18n,
        eventCountry: settings.eventCountry,
        registrantIndex: settings.registrantIndex,
        registrantsPersonalInformation: settings.registrantsPersonalInformation,
      })
      .questionsPlugin('initializeContent');
  };

  const initializeTeamFundraisingSettings = ($element) => {
    if (!$element) {
      return;
    }

    if (!$element.length) {
      return;
    }

    // hack to get the JS to wait for DOM update before doing things
    $element[0].getBoundingClientRect();

    if (!$element.children().length) {
      return;
    }

    $element
      .fundraisingSettingsPlugin({
        i18n: settings.i18n,
        registrationPlugin: settings.registrationPlugin,
      })
      .fundraisingSettingsPlugin('initializeContent');
  };

  /**
   * Validate the team name during creation for the registrant
   */
  const validateTeamName = (event) => {
    const $this = $(event.currentTarget);
    const $teamNameContainer = $this.closest('.form-group');
    const $teamNameFeedback = $teamNameContainer.find(selectors.teamNameFeedback);
    const $teamNameFeedbackIcon = $teamNameContainer.find(selectors.teamNameFeedbackIcon);

    $teamNameContainer.removeClass([classes.hasSuccess, classes.hasError]);
    $teamNameFeedbackIcon
      .removeClass([classes.iconCheck, classes.iconTimes, classes.hidden])
      .addClass(classes.iconSpinner);
    $teamNameFeedback.addClass(classes.hidden).empty();

    $.ajax({
      url: routes.validateTeamName
        .replace('__registrationUrl__', settings.registrationUrl)
        .replace('__registrantIndex__', settings.registrantIndex),
      type: 'POST',
      data: {
        name: $this.val(),
      },
    })
      .always(() => {
        $teamNameFeedbackIcon.removeClass([
          classes.iconCheck,
          classes.iconTimes,
          classes.iconSpinner,
        ]);
      })

      .done(() => {
        $teamNameFeedbackIcon.addClass(classes.iconCheck);
        $teamNameContainer.addClass(classes.hasSuccess);
      })

      .fail((response) => {
        $teamNameFeedbackIcon.addClass(classes.iconTimes);
        $teamNameContainer.addClass(classes.hasError);
        $teamNameFeedback
          .removeClass(classes.hidden)
          .text(response.responseJSON.errors['team-name']);
      });
  };

  /**
   * Load the category selector for joining existing and creating
   *
   * @param teamState
   */
  const loadCategories = (teamState) => {
    showLoadingState();

    $.ajax({
      url: routes.loadCategories
        .replace('__registrationUrl__', settings.registrationUrl)
        .replace('__registrantIndex__', settings.registrantIndex)
        .replace('__teamState__', teamState),
      type: 'GET',
    })
      .always(() => hideLoadingState())

      .done((response) => {
        const $categoriesContainer = $pluginContainer
          .find(selectors.teamCategoryContainer)
          .html(response);
        const $categories = $categoriesContainer.find(selectors.teamCategory);
        const $selectableCategories = $categories.find('option:enabled');

        // If there is only one category, pick it for them
        if ($selectableCategories.length === 1) {
          $categories.val($selectableCategories.val());
        }

        // Trigger the change in case the category is pre-populated
        $categories.trigger('change');
      })

      .fail(() => {
        // TODO: Error states
      });
  };

  /**
   * Load the questions for joining provisional teams
   *
   * @param categoryId
   * @param teamState
   * @param teamId
   * @param provisionalTeamId
   */
  const loadQuestionsForm = (categoryId, teamState, teamId = null, provisionalTeamId = null) => {
    showLoadingState();

    $.ajax({
      url: routes.loadQuestions
        .replace('__registrationUrl__', settings.registrationUrl)
        .replace('__registrantIndex__', settings.registrantIndex)
        .replace('__categoryId__', categoryId),
      type: 'GET',
      data: {
        teamId,
        provisionalTeamId,
        teamState,
      },
    })
      .always(() => hideLoadingState())

      .done((response) => {
        const $questions = $pluginContainer.find(selectors.teamQuestions).html(response);
        initializeTeamQuestions($questions);
      })

      .fail(() => {
        // TODO: Error states
      });
  };

  const fetchPreferredFundraisingOrganizationSelectionForTeam = (teamId, isProvisional) => {
    showLoadingState();

    const baseUrl = `${settings.registrationUrl}/registrant/${settings.registrantIndex}`;

    $.ajax({
      url: `${baseUrl}/team/${teamId}/get-preferred-fundraising-organization-selection`,
      type: 'GET',
      data: {
        isProvisional,
      },
    })
      .always(() => hideLoadingState())

      .done((response) => {
        $pluginContainer.find('.js-team-preferred-fundraising-organization-display')
          .html(response).removeClass(classes.hidden);
      })

      .fail(() => {
        clearPreferredFundraisingContainer();
      });
  };

  /**
   * Toggle the fundraising commitment for the selected team
   */
  const toggleFundraisingCommitment = () => {
    const $allCommitments = $pluginContainer.find(selectors.teamFundraisingCommitment);
    $allCommitments.addClass(classes.hidden);

    const $checkedState = $pluginContainer
      .find(selectors.teamStateInput)
      .filter(':checked, [type="hidden"]')
      .first();
    const stateVal = $checkedState.val();

    let fundraisingOrganizationUuid;
    let $commitmentScope = null;

    if (stateVal === teamStates.joiningExisting || stateVal === teamStates.joiningReserved) {
      const $joinSelect = $pluginContainer.find(selectors.teamsJoinFormControl);
      fundraisingOrganizationUuid = $joinSelect.find('option:selected').data('fundraising-organization-uuid');
      $commitmentScope = $pluginContainer.find(
        [selectors.teamJoinExisting, selectors.teamJoinReserved].join(', '),
      );
    } else if (
      stateVal
      && stateVal !== teamStates.noTeam
      && stateVal !== teamStates.creating
    ) {
      fundraisingOrganizationUuid = $checkedState.data('fundraising-organization-uuid');
      $commitmentScope = $pluginContainer.find(selectors.teamStateSelector);
    }

    if (fundraisingOrganizationUuid && $commitmentScope && $commitmentScope.length) {
      $commitmentScope
        .find(selectors.teamFundraisingCommitment)
        .filter(`[data-fundraising-organization-uuid="${fundraisingOrganizationUuid}"]`)
        .removeClass(classes.hidden);
    }

    triggerFundraisingOrganizationChanged(fundraisingOrganizationUuid);
  };

  /**
   * Load forms when team state changes
   */
  const changeTeamState = (event) => {
    const $this = $(event.currentTarget);
    const teamState = $this.val();

    // If joining an existing team or creating a new team, we need to load category selection
    if ([teamStates.joiningExisting, teamStates.creating, teamStates.joiningReserved].includes(teamState)) {
      // Remove the already loaded forms
      clearContainers();

      if (settings.newFundraisingFlow) {
        toggleFundraisingCommitment();
      }

      // Load the categories
      loadCategories(teamState);
    } else if (teamState.includes(teamStates.joiningPreSelected)) {
      if (settings.newFundraisingFlow) {
        toggleFundraisingCommitment();
      } else {
        fetchPreferredFundraisingOrganizationSelectionForTeam(
          parseInt(teamState.replace(`${teamStates.joiningPreSelected}-`, ''), 10),
          false,
        );
      }
    } else if (teamState !== teamStates.noTeam) {
      // Remove the already loaded forms
      clearContainers();

      // Otherwise, we can assume the team has been selected and we know the category
      // The category ID is stored on the provisional team options
      const categoryId = parseInt($this.data('category-id'), 10);
      const teamId = parseInt($this.data('team-id'), 10);
      const isProvisional = !!$this.data('is-provisional');

      // Load the questions for the team
      loadQuestionsForm(
        categoryId,
        teamState,
        !isProvisional ? teamId : null,
        isProvisional ? teamId : null,
      );

      if (settings.newFundraisingFlow) {
        toggleFundraisingCommitment();
      } else {
        if (parseInt($this.data('has-preferred-fundraising-provider-selection'), 10) === 1) {
          fetchPreferredFundraisingOrganizationSelectionForTeam(teamId, isProvisional);
        } else {
          clearPreferredFundraisingContainer();
        }
      }
    } else {
      // Remove the already loaded forms
      clearContainers();

      if (settings.newFundraisingFlow) {
        toggleFundraisingCommitment();
      }
    }
  };

  /**
   * Toggle the password field for the selected team joining
   */
  const togglePassword = ($input) => {
    const $existingTeam = $input.find('option:selected');
    const $password = $pluginContainer.find(selectors.joiningTeamPassword);
    const hasPassword = $existingTeam.data('password');

    // Toggle the display and disabled state of the password field base on if the existing team has a password
    $password.toggleClass(classes.hidden, !hasPassword).prop('disabled', !hasPassword);
  };

  /**
   * If the selected team has preferred fundraising organizations, go get em
   */
  const maybeFetchPreferredFundraisingOrganizations = ($input, isProvisional) => {
    const $selected = $input.find(':selected');
    const value = $selected.val();

    if (parseInt($selected.data('has-preferred-fundraising-provider-selection'), 10) === 1) {
      fetchPreferredFundraisingOrganizationSelectionForTeam(value, isProvisional);
    } else {
      clearPreferredFundraisingContainer();
    }
  };

  /**
   * Do all the things that need to happen when the team selector changes
   */
  const reactToTeamSelection = () => {
    const $input = $pluginContainer.find(selectors.teamsJoinFormControl);
    const value = $input.val();
    const isProvisional = !!$input.data('is-provisional');

    togglePassword($input);
    if (settings.newFundraisingFlow) {
      toggleFundraisingCommitment();
    } else {
      maybeFetchPreferredFundraisingOrganizations($input, isProvisional);
    }

    if (value) {
      loadQuestionsForm(
        $input.data('category'),
        $input.data('team-state'),
        isProvisional ? null : value,
        isProvisional ? value : null,
      );
    }
  };

  /**
   * A horribly hacky way to make select2 render filtered team options 50 at a time with
   * infinite scrolling. My deepest regrets and apologies to whoever winds up having to debug
   * through this absolute disaster of a rotten jQuery soup.
   * @param teams
   * @param $teamSelector
   * @param language
   */
  const setupAdvancedTeamSelector = (teams, $teamSelector, language) => {
    $.fn.select2.amd.require([
      'select2/data/array',
      'select2/utils',
    ], (ArrayData, Utils) => {
      function CustomData($element, options) {
        CustomData.__super__.constructor.call(this, $element, options);
      }

      Utils.Extend(CustomData, ArrayData);

      CustomData.prototype.query = (params, callback) => {
        const pageSize = 50;

        if (!('page' in params)) {
          params.page = 1;
        }

        const filteredTeams = ('term' in params && params.term.length)
          ? teams.filter((team) => {
            if (!team.text || !team.id) {
              return false;
            }

            if (team.text.toLowerCase().includes(params.term.trim().toLowerCase())) {
              return true;
            }

            return false;
          })
          : [];

        const filteredResultsPage = filteredTeams.slice((params.page - 1) * pageSize, params.page * pageSize);

        const data = {
          results: filteredResultsPage,
          pagination: {
            more: params.page * pageSize < filteredTeams.length,
          },
        };

        callback(data);
      };

      $teamSelector
        .on('change', (event) => {
          const $input = $(event.currentTarget);
          event.stopPropagation();
          const value = $input.val();

          if (value) {
            const teamId = parseInt(value, 10);
            const selectedTeam = teams.find((team) => team.id === teamId);

            if (selectedTeam) {
              $input
                .find(':selected')
                .attr('data-password', selectedTeam.hasPassword ? '1' : '0')
                .attr('data-password-pre-authenticated', selectedTeam.preAuthenticated ? '1' : '0')
                .attr(
                  'data-has-preferred-fundraising-provider-selection',
                  selectedTeam.hasPreferredFundraisingSelection ? '1' : '0',
                );
              if (settings.newFundraisingFlow && selectedTeam.fundraisingOrganizationUuid) {
                $input.find(':selected').attr('data-fundraising-organization-uuid', selectedTeam.fundraisingOrganizationUuid);
              }
            }
          }

          reactToTeamSelection();
        })
        .select2({
          ajax: {},
          dataAdapter: CustomData,
          language,
        });
    });
  };

  /**
   * Decodes HTML entities. Using a textarea value ensures HTML tags don't make it through
   * @param encodedString
   * @returns {string}
   */
  const decodeEntities = (encodedString) => {
    const textArea = document.createElement('textarea');

    textArea.innerHTML = encodedString;

    const { value } = textArea;

    textArea.remove();

    return value;
  };

  /**
   * Sets up the team selector. If the backend responds with a teams object, that means
   * we need the advanced setup. Otherwise just add select2 if there are more than 10 teams,
   * otherwise just a regular ol' select.
   * @param response
   */
  const setupTeamSelection = (response) => {
    const $teamSelector = $pluginContainer.find(selectors.teamsJoinFormControl);
    const $options = $teamSelector.find('option').not('[data-js-placeholder]');
    const selectedTeam = $teamSelector.val();
    const language = {
      loadingMore: () => settings.i18n.loading,
      noResults: () => {
        // this is hacky but there really isn't any other choice
        // if the search box has something typed into it
        if (!$('[aria-controls="select2-teams-join-existing-results"]').val()) {
          return decodeEntities(settings.i18n.searchByTeamName);
        }

        return settings.i18n.noResultsFound;
      },
      searching: () => settings.i18n.loading,
    };

    if ('teams' in response) {
      const teams = Object
        .values(response.teams)
        .map((team) => ({
          ...team,
          text: team.name,
          disabled: team.isDisabled,
        }))
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }

          if (a.name > b.name) {
            return 1;
          }

          return 0;
        });

      setupAdvancedTeamSelector(teams, $teamSelector, language);
    } else if ($options.length >= 10) {
      $teamSelector.select2({
        language,
      });
    }

    if (selectedTeam) {
      $teamSelector.trigger('change');
    }
  };

  /**
   * Load the join existing teams form
   *
   * @param categoryId
   */
  const loadJoinExistingForm = (categoryId) => {
    showLoadingState();

    $.ajax({
      url: routes.loadJoinExistingForm
        .replace('__registrationUrl__', settings.registrationUrl)
        .replace('__registrantIndex__', settings.registrantIndex)
        .replace('__categoryId__', categoryId),
      type: 'GET',
    })
      .always(() => hideLoadingState())
      .done((response) => {
        const $form = $pluginContainer.find(selectors.teamJoinExisting).html(response.html);

        setupTeamSelection(response);

        $form.questionsPlugin({
          registrationPlugin: settings.registrationPlugin,
          i18n: settings.i18n,
          eventCountry: settings.eventCountry,
        });
        $form.questionsPlugin('initializeContent');
      })

      .fail(() => {
        // TODO: Error states
      });
  };

  /**
   * Load the join reserved teams form
   *
   * @param categoryId
   */
  const loadJoinReservedForm = (categoryId) => {
    showLoadingState();

    $.ajax({
      url: routes.loadJoinReservedForm
        .replace('__registrationUrl__', settings.registrationUrl)
        .replace('__registrantIndex__', settings.registrantIndex)
        .replace('__categoryId__', categoryId),
      type: 'GET',
    })
      .always(() => hideLoadingState())
      .done((response) => {
        const $form = $pluginContainer.find(selectors.teamJoinReserved).html(response.html);

        setupTeamSelection(response);

        $form.questionsPlugin({
          registrationPlugin: settings.registrationPlugin,
          i18n: settings.i18n,
          eventCountry: settings.eventCountry,
        });
        $form.questionsPlugin('initializeContent');
      })

      .fail(() => {
        // TODO: Error states
      });
  };

  /**
   * Load the create team form
   *
   * @param categoryId
   */
  const loadCreateForm = (categoryId) => {
    showLoadingState();

    $.ajax({
      url: routes.loadCreateForm
        .replace('__registrationUrl__', settings.registrationUrl)
        .replace('__registrantIndex__', settings.registrantIndex)
        .replace('__categoryId__', categoryId),
      type: 'GET',
    })
      .always(() => hideLoadingState())
      .done((response) => {
        const $createForm = $pluginContainer.find(selectors.teamCreateNew).html(response);

        $createForm.find(selectors.teamNameInput).on('change', validateTeamName);

        const $fundraisingSettings = $pluginContainer.find(selectors.teamFundraisingSettings);
        const $oldPreferredOrg = $createForm.find('.js-team-preferred-fundraising-organization-old');
        if (settings.newFundraisingFlow) {
          $oldPreferredOrg.addClass(classes.hidden);
          $fundraisingSettings.removeClass(classes.hidden);
          initializeTeamFundraisingSettings($fundraisingSettings);

          const $teamFundraisingOptIn = $createForm.find(selectors.teamFundraisingOptIn);
          const $selectedFundraisingOrganization = $createForm
            .find(selectors.selectedTeamFundraisingOrganization);
          const relayFundraisingOrganization = () => {
            const hasOptedIn = !$teamFundraisingOptIn.length
              || $teamFundraisingOptIn.is(':checked');
            const fundraisingOrganizationUuid = hasOptedIn
              ? $selectedFundraisingOrganization.val()
              : null;

            triggerFundraisingOrganizationChanged(fundraisingOrganizationUuid);
          };

          $teamFundraisingOptIn.on('change.teamCharityLock', relayFundraisingOrganization);
          $selectedFundraisingOrganization
            .on('change.teamCharityLock', relayFundraisingOrganization);
          relayFundraisingOrganization();
        } else {
          $oldPreferredOrg.removeClass(classes.hidden);
          $fundraisingSettings.addClass(classes.hidden);
        }

        loadQuestionsForm(categoryId, teamStates.creating);
      })

      .fail(() => {
        // TODO: Error states
      });
  };

  /**
   * Select the team category
   */
  const loadTeamForms = (event) => {
    const $this = $(event.currentTarget);
    const categoryId = parseInt($this.val(), 10);
    const teamState = $teamStates.filter(':checked').val();

    // Do nothing if the category is not valid
    if (Number.isNaN(categoryId) || categoryId < 1) {
      return;
    }

    // Clear out the create and join existing forms when switching categories
    $pluginContainer.find(
      [
        selectors.teamCreateNew,
        selectors.teamJoinExisting,
        selectors.teamJoinReserved,
        selectors.teamQuestions,
        selectors.teamFundraisingSettings,
      ].join(', '),
    ).empty();

    switch (teamState) {
      case teamStates.joiningExisting:
        loadJoinExistingForm(categoryId);
        break;
      case teamStates.joiningReserved:
        loadJoinReservedForm(categoryId);
        break;
      case teamStates.creating:
        loadCreateForm(categoryId);
        break;
      default:
        // nothing
    }
  };

  /**
   *
   * @param {jQuery} element
   * @param {*} options
   */
  const Plugin = function teamsPlugin(element, options) {
    this.element = element;
    settings = $.extend({}, defaults, options);
    this.settings = settings;

    // Set the container for the plugin
    $pluginContainer = element;
  };

  /**
   * Clear the plugin's contents
   */
  Plugin.prototype.clear = () => {
    $pluginContainer.empty();
  };

  /**
   * Toggle the visibility of this component
   *
   * @param isVisible
   */
  Plugin.prototype.toggleVisibility = (isVisible) => {
    $pluginContainer.toggleClass(classes.hidden, !isVisible);
  };

  /**
   * Display the plugin's contents
   *
   * @param content
   */
  Plugin.prototype.displayContent = (content) => {
    // sometimes the content already exists in the html, so we can skip this
    if (content) {
      $pluginContainer.html(content);
    }

    $teamStates = $pluginContainer.find(selectors.teamStateInput);
    $teamSpinner = $pluginContainer.find(selectors.teamSpinner);

    const $teamStateInput = $teamStates.filter('input[type="hidden"]');

    // Binding for team state change
    $teamStates.on('change', changeTeamState);

    // Load the team forms on team category selection
    $pluginContainer.on('change', selectors.teamCategory, loadTeamForms);

    $pluginContainer
      // Toggle the password field on existing/reserved team join change
      .on('change', selectors.teamsJoinFormControl, reactToTeamSelection)
      // Trigger change for the joined existing/reserved team if pre-populated
      // this will toggle display of the password field
      .trigger('change');

    // Bind team name validation for pre-populated create form
    $pluginContainer.find(selectors.teamNameInput).on('change', validateTeamName);

    initializeTeamQuestions($pluginContainer.find(selectors.teamQuestions));

    if ($teamStateInput.length) {
      $teamStates.trigger('change');
    }

    if (settings.newFundraisingFlow) {
      toggleFundraisingCommitment();
    }
  };

  /**
   * Initialize the functional components of the content
   */
  Plugin.prototype.initializeContent = () => {
    Plugin.prototype.displayContent();
  };

  /**
   * Plugin wrapper, preventing against multiple instantiations and
   * return plugin instance.
   */
  $.fn[pluginName] = function pluginWrapper(options) {
    let thisPlugin = this.data(dataKey);

    // has plugin instantiated ?
    if (thisPlugin instanceof Plugin) {
      // if have options arguments, call plugin.init() again
      if (typeof options !== 'undefined') {
        thisPlugin.init(options);
      }
    } else {
      thisPlugin = new Plugin(this, options);
      this.data(dataKey, thisPlugin);
    }

    return thisPlugin;
  };
});
